/**
 * i18n Configuration
 * Internationalization setup with language detection
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Load translations from /public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'ar'],
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    ns: ['common', 'dashboard', 'customers', 'products', 'invoices', 'expenses', 'settings'],
    defaultNS: 'common',

    react: {
      useSuspense: true,
    },
  });

export default i18n;

// RTL languages
export const RTL_LANGUAGES = ['ar', 'he', 'fa'];

// Check if current language is RTL
export const isRTL = (lang?: string) => {
  const currentLang = lang || i18n.language;
  return RTL_LANGUAGES.includes(currentLang);
};

// Language options for selector
export const LANGUAGE_OPTIONS = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
];
